<template>
  <div class="chat-container">
    <div class="messages-container">
      <div v-for="(message, index) in data" :key="index">
        <div v-if="newMessagePosition === index">
          <hr>
        </div>
        <div v-if="message.bot === 0" class="message-container is-user">
          <span class="message-text">{{ message.message }}</span>
          <span class="date">{{ message.date }}</span>
        </div>
        <div v-else class="message-agent">
          <div class="message-container is-agent" :class="getTypeResponse(message)">
            <span class="message-text">{{ message.message }}</span>
            <span v-if="showIntention(message)" class="intention">
              <span @click="openIntention(message.idClient, message.idIntent)" class=" icon is-small cpointer"><i class="fas fa-eye"></i> </span> {{ CONSTANTS.getCopy('CHAT_INTENT') }} {{ message.intent }} | {{ CONSTANTS.getCopy('CHAT_PHRASE') }} {{ message.term }}{{ getKeyword(message) }}
              {{ checkIsChatGPT(message) ? ` | Título del prompt: ${message.prompt}` : ''}}
            </span>
            <span v-if="checkIsAgent(message) || message.template" class="intention">
              Agente: {{ checkIsAgent(message) ? message.agentName : message.agentTemplate }}
            </span>
            <span class="date">{{ message.date }}</span>
          </div>
          <div class="bot-icon">
            <img v-if="checkIsAgent(message)" src="../../assets/chat/agent-icon.png" />
            <img v-if="checkIsBot(message)" src="../../assets/chat/bot-icon.png" />
            <img v-if="message.template" src="../../assets/chat/template-icon.png" />
            <img v-if="message.dialogflow" src="../../assets/chat/dialogflow-icon.png" />
            <img v-if="message.chatGPT === 1" src="../../assets/chat/kdcagpt-interno.png" />
            <img v-if="message.chatGPT === 2" src="../../assets/chat/kdcagpt-visible.png" />
          </div>
        </div>
      </div>
    </div>
    <div class="new-messages-container" v-if="showNewMessagesBanner">
      <span class="banner" @click="showNewMessages">{{ CONSTANTS.getCopy('CHAT_NEW_MESSAGES') }}</span>
    </div>
    <div class="input-container" v-if="!isBot && showMessageInput">
      <div class="emoji-icon" @click="showEmojis = !showEmojis">
        <img src="../../assets/chat/emoji-icon.png" />
      </div>
      <div class="text-container">
        <textarea v-model="message" @keypress="checkEnter"></textarea>
      </div>
      <div>
        <div class="send-button" @click="sendMessage">
          <img src="../../assets/chat/send-icon.png" />
        </div>
        <div class="enter-funcionality">
          <input type="checkbox" v-model="enterFunctionality" id="enterFunction" @change="toggleEnterFunctionality()" />
          <label for="enterFunction">{{ CONSTANTS.getCopy('CHAT_ENTER_LABEL') }}</label>
        </div>
      </div>
    </div>
    <emojis v-if="showEmojis" class="emoji-container" :emojis="emojis" @emoji-selected="addEmoji"></emojis>
  </div>
</template>

<script>

import Emojis from '../templates/Emojis'
import responseTypes from '../../lib/ChatResponseTypes'

export default {
  components: { Emojis },
  props: { chatId: Number, isBot: Boolean },
  data () {
    return {
      data: [],
      message: '',
      showEmojis: false,
      showMessageInput: false,
      emojis: [],
      enterFunctionality: false,
      isFirstTime: true,
      keepScrool: false,
      showNewMessagesBanner: false,
      newMessagePosition: -1
    }
  },
  created () {
    setInterval(() => this.getChatData(), 4000)
    this.getEmojis()
    this.enterFunctionality = parseInt(localStorage.getItem('enterFunctionality')) === 1
  },
  updated () {
    let scroll = document.querySelector('.messages-container')
    if (this.isFirstTime) scroll.scrollTop = scroll.scrollHeight
    if (this.isFirstTime && this.keepScrool) this.isFirstTime = false
    if (!this.keepScrool) scroll.scrollTop = scroll.scrollHeight
  },
  watch: {
    chatId () {
      this.showNewMessagesBanner = false
      this.isFirstTime = true
      this.newMessagePosition = -1
      if (!this.chatId) {
        this.data = null
        this.showMessageInput = false
        this.showEmojis = false
        return
      }
      this.showMessageInput = true
      this.showEmojis = false
      this.getChatData()
    }
  },
  methods: {
    getChatData (isASentMessage = false) {
      if (this.chatId === undefined || !this.chatId) {
        return
      }
      this.api.post('/ChatsConversation', { idChat: this.chatId }, false).then(response => {
        if (!this.isFirstTime && this.data && (this.data.length < response.chatConversation.length) && !isASentMessage) {
          this.showNewMessagesBanner = true
          this.newMessagePosition = parseInt(this.newMessagePosition) === -1
            ? this.data.length
            : this.data.length - (this.data.length - this.newMessagePosition)
        }
        this.data = response.chatConversation
        this.keepScrool = true
        if (!this.isFirstTime && !this.showNewMessagesBanner) this.newMessagePosition = -1
        if (this.checkScrollDown() && !this.isFirstTime) {
          this.showNewMessagesBanner = false
          this.newMessagePosition = -1
          this.keepScrool = false
        }
        if (isASentMessage) this.keepScrool = false
      })
    },
    sendMessage () {
      this.api.post('/ChatsAgentMessage', { idChat: this.chatId, message: this.message }).then((response) => {
        this.getChatData(true)
        this.message = ''
      })
    },
    getKeyword (message) {
      if (message.typeResponse === 0 && message.keyword) {
        return ` | Keyword: ${message.keyword}`
      }
    },
    getEmojis () {
      this.api.post('/DataEmojiList').then(response => {
        this.emojis = response.emojis
        this.emojis.shift()
      })
    },
    addEmoji (emoji) {
      this.message += emoji
    },
    checkEnter (e) {
      if (e.key === 'Enter' && this.enterFunctionality) this.sendMessage()
    },
    checkIsChatGPT (message) {
      return message.chatGPT === 1 || message.chatGPT === 2
    },
    toggleEnterFunctionality () {
      localStorage.setItem('enterFunctionality', this.enterFunctionality ? 1 : 0)
    },
    showNewMessages () {
      let scroll = document.querySelector('.messages-container')
      scroll.scrollTop = scroll.scrollHeight
      this.showNewMessagesBanner = false
    },
    checkScrollDown () {
      let scroll = document.querySelector('.messages-container')
      let containerHeight = scroll.clientHeight
      let scrollHeight = scroll.scrollHeight
      let scrollTop = scroll.scrollTop

      return (containerHeight === (scrollHeight - scrollTop))
    },
    getTypeResponse (message) {
      let className = 'agent'
      if (message.template) return 'template'
      if (message.dialogflow) return 'dialogflow'
      if (message.chatGPT === 1 || message.chatGPT === 2) return 'chatgpt'

      if (message.agent) {
        return className
      }
      switch (message.typeResponse) {
        case responseTypes.OK:
          className = 'ok'
          break
        case responseTypes.DOUBT:
          className = 'doubt'
          break
        default:
          className = 'error'
      };
      return className
    },
    checkIsAgent (message) {
      return (message.agent && !message.template && !message.dialogflow)
    },
    checkIsBot (message) {
      return (!message.agent && !message.template && !message.dialogflow && message.chatGPT === 0)
    },
    showIntention (message) {
      return (message.agent === 0 && message.typeResponse !== 2 && message.intent) || (message.chatGPT === 1 || message.chatGPT === 2)
    },
    openIntention (idClient, idIntent) {
      window.open(`/#/clients/${idClient}/intents/${idIntent}/sentences`)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Chats/Chat.vue